export const MainMenuItemType = {
    CONTACTS: 'menu-item-contact-list',
    CONVERSATIONS: 'menu-item-conversation-list',
    CHANNELS: 'menu-item-channels',
    GEOLOCATION: 'menu-item-geolocation',
    MY_BUSINESS: 'menu-item-my-business',
    SETTINGS: 'menu-item-settings',
    MY_TOOLS: 'menu-item-my-tools',
};

export const MasterPageType = {
    CONTACTS: 'contacts',
    SETTINGS: 'settings',
};

export const DefaultPageMapping = {
    contacts: MainMenuItemType.CONTACTS,
    conversations: MainMenuItemType.CONVERSATIONS,
    channels: MainMenuItemType.CHANNELS,
    geolocation: MainMenuItemType.GEOLOCATION,
    mybusiness: MainMenuItemType.MY_BUSINESS,
    settings: MainMenuItemType.SETTINGS,
    myrules: MainMenuItemType.MY_TOOLS,
};
